import { PageHeader } from "@/widgets/page-header"
import { GroupsGrid } from "./groups-grid"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { CreateGroup } from "@/features/groups/ui/create-group"

export const UsersGroupsPage = () => {
    return (
        <div className="_page_container">
            <PageHeader title="пользователи" />
            <div className="flexbox">
                <PageSubtitle title={'Группы'} />
                <div className="w-full flex justify-end gap-2">
                    <div className="w-full bg-white h-[52px] rounded-full block"/>
                    <CreateGroup 
                        role={"users"}                  
                    />
                </div>
                <GroupsGrid />
            </div>
        </div>
    )
}